import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { spinnerOff, spinnerOn } from '../../components/Spinner';
import { post, startIPSProject } from '../../api';

import IpsDTProjectGrid from '../../components/ProjectsGrid/IpsDTProjectGrid';

import IpsDTProjectList from 'components/ProjectsList/IpsDTProjectList';
import IPSDTViewType from 'components/ViewType/IPSDTViewType';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import SearchStationPendingTab from '../common/SearchStationPendingTab';
import { Button, Col } from 'antd';
import { handleStartDataTracker, redirect,startProjectPendingProject } from '../../utils/Dashboard';

export default withRouter(function DataTrackerPending(props) {
  const {
    context,
    history,
    cardview,
    onViewTypeChange,
    projectList,
    ipsStations,
  } = props;
  const [projects, setProjects] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  
  let tab = history.location.pathname.split('/')[2];
  useEffect(() => {
    async function getProjects() {
      if (projects && projects.length < 1) {
        spinnerOn();
        setIsLoading(true);

        const result = await post(`ipsprojects/pending`, '', {});

        setProjects(result.data);

        spinnerOff();
        setIsLoading(false);
      }
    }

    getProjects();
  }, []);
  
  

 

  function startProject(project) {
    let redirectInfo = {history,context}

    startProjectPendingProject(project,ipsStations,handleStartDataTracker ,redirectInfo);
    
  }

  return (
    <Fragment>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flewGrow: 1,
          justifyContent: 'center',
          paddingRight: '16px',
          paddingBottom: '16px',
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <IPSDTViewType
          onViewTypeChange={onViewTypeChange}
          tabView={'DT_P'}
          dtstatus={'DT_P'}
        />
      </div>
      {cardview === 'cardview' ? (
        <IpsDTProjectGrid
          projects={projectList(projects)}
          history={history}
          context={context}
          onButtonClick={startProject}
          isLoading={isLoading}
          {...props}
        />
      ) : (
        <IpsDTProjectList
          projects={projectList(projects)}
          onButtonClick={startProject}
          {...props}
          tabView={tab}
        />
      )}
      {}
    </Fragment>
  );
});
